import React from "react";


const PressReleaseComponent = () => {
  return (
    <div className="about_area mt-65 mb-140 pb-60 press-r">
      <div className="container">
        <div className="row d-flex align-items-center pd_gap nagative_mb">
          <div className="col-lg-6">
            <div className="about_skill_thumb mb-4 ml-2 mr-4">
              <img src={"/assets/images/cm-x-proplus-data.jpeg"} alt="Custom Media - ProPlus Data Partnership" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="section_title text_left mb-5">
             

              <div className="section_main_title text-left">
                <h5>Custom Media to Partner with ProPlus Data for Account-Based Marketing Services</h5>
               
              </div>

              

              <div className="section_content_text pt-4">
                <p>
                <a href="https://custom-media.com/" target="_blank" rel="noreferrer">Custom Media</a>, an award-winning B2B marketing agency based in Tokyo, Japan, has entered a partnership with <a href="https://proplusdata.co/" target="_blank" rel="noreferrer">ProPlus Data</a>, a data insight and prospect intelligence company based in Pune, India and Tokyo, Japan, to improve their delivery of account-based marketing (ABM) and account-based experience (ABX) services to its clients.
                </p>
                <p>Read More At: <a href="https://www.einpresswire.com/article/703080658/custom-media-to-partner-with-proplus-data-for-account-based-marketing-services" target="_blank" rel="noreferrer"> EINPRESSWIRE </a> |<a href="https://www.linkedin.com/posts/proplus-data_proplus-data-japan-partnership-2024-activity-7185505879373332481-jF0C?utm_source=share&utm_medium=member_desktop" target="_blank" rel="noreferrer"> LINKEDIN </a>| <a href="https://fox2now.com/business/press-releases/ein-presswire/703080658/custom-media-to-partner-with-proplus-data-for-account-based-marketing-services/" target="_blank" rel="noreferrer"> FOX2NOW </a></p>
              </div>
            </div>

          

          </div>
        </div>
      </div>
    </div>
  );
};

export default PressReleaseComponent;
